import {Injectable} from "@angular/core";
import {APIRequestResources, CachedAPIRequest, PaginationResponse} from "../../core";
import {BehaviorSubject, catchError, tap} from "rxjs";
import {toSignal} from "@angular/core/rxjs-interop";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {handleError} from "../../core/util/util";
import {CroData, CroDTO} from "../interfaces/cro.entity";


@Injectable({
    providedIn: 'root'
})
export class CROService extends CachedAPIRequest {

    private readonly $all = new BehaviorSubject<CroDTO[]>([]);
    all = toSignal(this.$all, {initialValue: []})

    private readonly $active = new BehaviorSubject<CroData | undefined>(undefined);
    active = toSignal(this.$active, {initialValue: undefined})

    constructor(protected override http: HttpClient, private router: Router) {
        super(http, APIRequestResources.CROService)
    }


    find(params:any,refresh = true) {
        return this.get<PaginationResponse<CroDTO[]>>({
            endpoint: `find`,
            params: params
        }, refresh ? 'freshness' : 'performance'). pipe(
            tap(res => this.$all.next(res.data.data ?? [])),
            catchError(handleError)
        )
    }

    getById = (id: string, refresh = true) => {
        return this.get<CroData>({id}, refresh ? 'freshness' : 'performance')
            .pipe(
                tap((res) => this.$active.next(res.data)),
                catchError(handleError)
            )

    }
    initial = () => {
        this.$active.next(undefined)
    }


}